import { ReactComponent as LockIcon } from 'assets/icons/lock.svg'
import { ReactComponent as ImageIcon } from 'assets/icons/image.svg'
import { ReactComponent as ArtIcon } from 'assets/icons/adjust.svg'
import { ReactComponent as LayoutIcon } from 'assets/icons/layout.svg'
import { ReactComponent as PaintBucketIcon } from 'assets/icons/color-bucket.svg'
import { ReactComponent as MoonIcon } from 'assets/icons/moon.svg'
import { ReactComponent as SunIcon } from 'assets/icons/sun.svg'
import { ReactComponent as CopyIcon } from 'assets/icons/copy-link.svg'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as PreviewIcon } from 'assets/icons/preview.svg'
import { ReactComponent as NextIcon } from 'assets/icons/chev-next.svg'

import ColorInput from '../../components/ColorInput/ColorInput'
import { useRef, useState } from 'react'
import MediaLibrary from '../../components/MediaLibrary/MediaLibrary'
import IconMenu from '../../components/IconMenu/IconMenu'
import clsx from 'clsx'
import Modal from 'react-modal'
import { Link, useNavigate } from 'react-router-dom'
import { diff } from 'deep-object-diff'
import { isEmpty } from 'lodash'
import { LocalToastTarget, useLocalToast } from 'react-local-toast'
import GeneralModal from '../../components/GeneralModal/GeneralModal'
import TextInput from '../../components/TextInput/TextInput'
import PasswordInput from '../../components/PasswordInput/PasswordInput'
import PortfolioEditSlugModal from './modals/PortfolioEditSlugModal'
import PortfolioBackgroundImageModal from './modals/PortfolioBackgroundImageModal'

const PortfolioEditorHeader = ({
  values,
  user,
  isPreview,
  originalValues,
  onChange,
  onPreview,
  onSave,
}) => {
  const { showToast } = useLocalToast()
  const navigate = useNavigate()
  const containerRef = useRef()
  const [backgroundImageModalIsOpen, setBackgroundImageModalIsOpen] =
    useState(false)
  const [backModalIsOpen, setBackModalIsOpen] = useState(false)
  const [editSlugModalIsOpen, setEditSlugModalIsOpen] = useState(false)
  const [editPassword, setEditPassword] = useState(null)

  const toastName = `copy-${values.id}`
  const lockColor = values.password ? '#d63b5c' : '#ccc'
  const previewColor = isPreview ? '#d63b5c' : '#ccc'
  const pageData = values?.pageData || {}
  const templates = [
    {
      id: 'profileRight',
      name: 'Profile on Right',
    },
    {
      id: 'profileLeft',
      name: 'Profile on Left',
    },
    {
      id: 'profileTop',
      name: 'Profile above Player',
    },
    {
      id: 'profileBottom',
      name: 'Profile below Player',
    },
    {
      id: 'playerOnly',
      name: 'Player Only',
    },
  ]
  function handleSlugChange({ slug }) {
    onChange({
      ...values,
      slug,
    })
    setEditSlugModalIsOpen(null)
  }

  function handleBackgroundImageSubmit(background) {
    const currentValues = pageData?.background || {}
    if (background) {
      handlePageDataChange('background', { ...currentValues, ...background })
    } else {
      handlePageDataChange('background', {
        ...(currentValues?.color ? { color: currentValues?.color } : {}),
      })
    }

    setBackgroundImageModalIsOpen(false)
  }

  function handleChangeBackgroundColor(color) {
    const currentValues = pageData?.background || {}
    handlePageDataChange('background', { ...currentValues, color })
  }

  function handlePasswordClick() {
    setEditPassword(values.password || '')
  }

  function handleEditPasswordSubmit(password) {
    onChange({
      ...values,
      password,
    })
    setEditPassword(null)
  }

  function handlePageDataChange(field, value) {
    onChange({
      ...values,
      pageData: {
        ...pageData,
        [field]: value,
      },
    })
  }

  function handleBack() {
    const differences = diff(values, originalValues)
    if (!isEmpty(differences)) {
      setBackModalIsOpen(true)
    } else {
      navigate('/portfolios')
    }
  }

  async function handleCopyClick(evt) {
    evt.stopPropagation()
    showToast(toastName, 'Copied!', { duration: 1250 })
    const { baseLink } = values
    const link = baseLink + values.slug
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(link)
    } else {
      document.execCommand('copy', true, link)
    }
  }

  return (
    <div>
      <div className="h-[40px] bg-deep flex px-4 items-center">
        <h3>
          <button
            onClick={handleBack}
            className="flex items-center justify-between mr-2"
          >
            Portfolios
          </button>
        </h3>
        <div className="mr-2">
          <NextIcon fill="#ccc" height="12" width="12" />
        </div>
        <h3 className="m-0 text-white-dark w-[700px] text-ellipsis overflow-hidden whitespace-nowrap">
          {values.name}
        </h3>
      </div>
      <div className="h-[50px] bg-gray-dark flex items-center px-4 z-[11] relative">
        <div className="pr-2 w-[150px]">
          <input
            type="text"
            value={pageData?.title}
            placeholder="Page Title"
            className="h-[36px]"
            onChange={(evt) => handlePageDataChange('title', evt.target.value)}
          />
        </div>
        <div className="relative flex ">
          <div className="slug-input flex items-center">/{values?.slug}</div>

          <div className="flex">
            <LocalToastTarget name={toastName}>
              <button
                className="flex justify-center items-center bg-gray-lighter h-[36px] w-[36px] border-t border-gray-dark border-b border-solid"
                onClick={handleCopyClick}
                data-tooltip="Copy Link URL"
              >
                <CopyIcon fill="#eee" height="18" />
              </button>
            </LocalToastTarget>

            <button
              className="flex justify-center items-center bg-gray-lighter h-[36px] w-[36px] border-t border-gray-dark border-b border-solid border-r rounded-r-half"
              onClick={() => setEditSlugModalIsOpen(true)}
              data-tooltip="Edit Link"
            >
              <EditIcon fill="#eee" height="18" />
            </button>
          </div>
        </div>
        <div className="flex-fill flex items-center px-6 ml-8">
          <div className="relative h-[50px] flex items-center">
            <button
              data-tooltip="Set Password"
              onClick={handlePasswordClick}
              className=""
            >
              <LockIcon
                fill={lockColor}
                stroke={lockColor}
                alt="Set Password"
              />
            </button>
          </div>
          <div className="w-[1px] bg-gray-bright h-[36px] mx-4"></div>
          <div
            ref={containerRef}
            className="relative h-[50px] flex items-center"
          >
            <ColorInput
              tooltip="Background Color"
              hideInput
              hideColorPreview
              containerClass="mr-4"
              value={pageData?.background?.color}
              containerRef={containerRef}
              icon={<PaintBucketIcon fill="#ccc" />}
              alpha={true}
              onChange={handleChangeBackgroundColor}
            />
            <button
              className="mr-0"
              data-tooltip="Background Image"
              onClick={() => setBackgroundImageModalIsOpen(true)}
            >
              <ImageIcon
                fill="#ccc"
                stroke={lockColor}
                width="36"
                height="36"
                alt="Set Background Image"
              />
            </button>
          </div>
          <div className="w-[1px] bg-gray-bright h-[36px] mx-4"></div>
          <div className="relative h-[50px] flex items-center">
            <IconMenu
              containerClass="mr-2"
              tooltip="Theme"
              icon={
                <ArtIcon fill="#ccc" width="30" height="30" alt="Set Theme" />
              }
            >
              <button
                onClick={() => handlePageDataChange('theme', 'light')}
                className={clsx({ 'is-active': pageData?.theme === 'light' })}
              >
                <SunIcon fill="#eee" width="22" />
                Light
              </button>
              <button
                onClick={() => handlePageDataChange('theme', 'dark')}
                className={clsx({
                  'is-active': !pageData?.theme || pageData?.theme === 'dark',
                })}
              >
                <MoonIcon fill="#eee" width="22" />
                Dark
              </button>
            </IconMenu>

            <div className="relative h-[50px] flex items-center">
              <IconMenu
                tooltip="Layout"
                icon={
                  <LayoutIcon
                    fill="#ccc"
                    width="30"
                    height="30"
                    alt="Set Theme"
                  />
                }
              >
                {templates.map(({ id, name }) => (
                  <button
                    onClick={() => handlePageDataChange('template', id)}
                    key={id}
                    className={clsx({
                      'is-active': pageData?.layout === id,
                    })}
                  >
                    {name}
                  </button>
                ))}
              </IconMenu>
            </div>
          </div>
          <div className="w-[1px] bg-gray-bright h-[36px] mx-4"></div>

          <div className="relative h-[50px] flex items-center">
            <button data-tooltip="Preview" onClick={onPreview} className="">
              <PreviewIcon fill={previewColor} alt="Preview" />
            </button>
          </div>
        </div>
        <div>
          <button className="button small bg-pink" onClick={onSave}>
            Save
          </button>
        </div>
      </div>

      {backgroundImageModalIsOpen ? (
        <PortfolioBackgroundImageModal
          isOpen={backgroundImageModalIsOpen}
          onRequestClose={() => setBackgroundImageModalIsOpen(false)}
          initialValues={pageData?.background}
          onSubmit={handleBackgroundImageSubmit}
        />
      ) : null}

      <Modal
        isOpen={backModalIsOpen}
        onRequestClose={() => setBackModalIsOpen(false)}
        contentLabel="Unsaved Changes"
        className="modal w-[500px]"
        overlayClassName="modal-overlay"
      >
        <div className="p-6 relative">
          <h2 className="mb-8">Unsaved Changes</h2>
          <p className="mt-4">
            You have unsaved changes. Do you still wish to leave this page?
          </p>
          <div className="flex justify-end mt-12">
            <button
              className="button "
              onClick={() => setBackModalIsOpen(false)}
            >
              Cancel
            </button>
            <Link to="/portfolios" className="button bg-red">
              Abandon Changes
            </Link>
          </div>
        </div>
      </Modal>
      {editSlugModalIsOpen ? (
        <PortfolioEditSlugModal
          portfolioId={values.id}
          isOpen={editSlugModalIsOpen}
          onRequestClose={() => setEditSlugModalIsOpen(false)}
          initialValues={{ slug: values.slug }}
          onSubmit={handleSlugChange}
        />
      ) : null}
      {editPassword !== null && (
        <GeneralModal
          isOpen={true}
          onRequestClose={() => {
            setEditPassword(null)
          }}
          title="Edit Password"
          secondaryButtons={[
            {
              className: 'button bg-red',
              text: 'Remove Password',
              disabled: !values.password,
              onClick: () => handleEditPasswordSubmit(null),
            },
          ]}
          buttons={[
            {
              className: 'button bg-pink',
              text: 'Save',
              disabled: !editPassword,
              onClick: () => handleEditPasswordSubmit(editPassword),
            },
          ]}
        >
          <label className="inline-block" htmlFor="password">
            Password
          </label>
          <PasswordInput
            label="Password"
            value={editPassword}
            name="password"
            onChange={(evt) => setEditPassword(evt.target.value)}
          />
        </GeneralModal>
      )}
    </div>
  )
}

export default PortfolioEditorHeader
